
        import * as module0 from '$components/cv-init.js';import * as module1 from '$components/cv.js';import * as module2 from '$components/mermaid-init.js'
        const modules = {
            "cv-init.js": module0,
            "cv.js": module1,
            "mermaid-init.js": module2,
        };
        export default modules;
      